import { CircularProgress } from "@mui/material";
import { useMemo, useState } from "react";

const ChatbotAccordionAddItem = ({
  onAddItem,
  isWeddingDaySchedule,
  isParsing,
  disableAction,
}) => {
  const [value, setValue] = useState("");
  const [isLoadingMutation, setIsLoadingMutation] = useState(false);

  const handleAddItem = async () => {
    if (disableAdd || isLoadingMutation) {
      return;
    }

    setIsLoadingMutation(true);

    await onAddItem({
      type: "add",
      item: {
        done: false,
        ...(isWeddingDaySchedule ? { event: value } : { task: value }),
      },
    });

    setIsLoadingMutation(false);
    setValue("");
  };

  const disableAdd = useMemo(() => {
    return !value.trim() || isParsing || disableAction;
  }, [isParsing, value, disableAction]);

  return (
    <div className="chatbot-accordion-add-item">
      <input
        type="text"
        placeholder="Add an additional item..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <div
        className={`button ${disableAdd ? "disabled" : ""}`}
        onClick={handleAddItem}
      >
        {isLoadingMutation ? (
          <CircularProgress size={20} color="secondary" />
        ) : (
          "Add"
        )}
      </div>
    </div>
  );
};

export default ChatbotAccordionAddItem;
